module.exports = __webpack_public_path__ + "img/person1-small@2x.d247b6d0.png";